function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $58bb66dede780caa$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"3EsVB":"index.5c46e4b0.js","cPzGy":"icons.c14567a0.svg"}'));


//# sourceMappingURL=index.cf76d0a8.js.map
